module.exports = __webpack_public_path__ + "assets/folder.svg?bc080fcd95eb9013a5f95cd7d732b364";